import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import SupportIcon from '@mui/icons-material/Support';

const Footer = () => {
    return (
        <footer>
            <Box
                sx={{
                    bgcolor: 'primary.main',
                    color: 'white',
                    textAlign: 'center',
                    py: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <Typography variant="body2">
                    © 2025 Ministry of Education Ethiopia. All rights reserved.
                </Typography>
                <Box 
                    component="a"
                    href="https://t.me/ngatsupportofficial"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5,
                        textDecoration: 'underline',
                        color: 'inherit',
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8
                        }
                    }}
                >
                    <SupportIcon sx={{ fontSize: 16 }} />
                    <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                        Contact Support
                    </Typography>
                </Box>
            </Box>
        </footer>
    );
};

export default Footer;

 